import { Requirement } from '../interfaces/treatment';

export class MRequirement{
    public help: string = null;
    public description: string = null;
    public id: number = null;
    public number: string = null;
    public mandatory: boolean = false;
    public order: number = null;

    constructor(req: Requirement){
        this.help = req.ayuda;
        this.description = req.descripcion;
        this.id = req.id;
        this.number = req.numero;
        this.mandatory = req.obligatorio;
        this.order = parseFloat(req.orden)
    }
}